import React from 'react';

// Multibrand-UI Components
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';
import Input from '@zg-rentals/multibrand-ui/lib/Input';

import api from 'app/shared/utils/api';

import { IconEdit, IconCloseOutline } from '@zillow/constellation';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import cx from 'classnames';

import UserManagementActions from 'app/shared/actions/UserManagementActions';

import pathsManifest from 'app/shared/pathsManifest';

const paths = pathsManifest.getAllPaths();

const TabList = {
    users: 'users',
    pending: 'pending',
    activity: 'activity',
};

const UserManagementNav = ({
    company,
    activeTab,
    history,
    dispatch,
}) => {
    const [isEditing, setIsEditing] = React.useState(false);
    const [companyName, setCompanyName] = React.useState('');
    const [editError, setEditError] = React.useState(null);

    const handleAddUser = () => {
        window.router.transitionTo(`${paths.userManagementPage}/${paths.userManagementAddUser}`);
    };

    const loadTab = (tab) => {
        const baseDetailsUrl = paths.userManagementPage;
        const url = `${baseDetailsUrl}/${tab}`;
        return history.push(url);
    };

    const handleEdit = () => {
        setEditError(null);
        setCompanyName(company.name);
        setIsEditing(true);
    };

    const handleSaveName = () => {
        dispatch(api.users.company.updateCompanyName(companyName))
            .then((response) => {
                if (!response.success) {
                    if (response.error && response.error.message) {
                        throw new Error(response.error.message);
                    }
                    throw new Error();
                }
                dispatch(UserManagementActions.setCompanyName(response.response));
                setIsEditing(false);
            })
            .catch((e) => {
                if (e && e.message) {
                    setEditError(e.message);
                } else {
                    setEditError('Failed to update Company Name, please try again');
                }
            });
    };

    const renderEditName = () => (
        <div className="edit-company-name-wrapper">
            <Input
                type="text"
                value={companyName}
                onChange={e => setCompanyName(e.target.value)}
                onKeyDown={e => e.keyCode === 13 && handleSaveName()}
                onBlur={handleSaveName}
                error={editError}
            />
            <IconCloseOutline className="close-edit-company-name-icon" onClick={() => setIsEditing(false)} />
        </div>
    );

    const renderHeading = () => company.name && (
        <>
            <Text inline={true} type="h3" emphasize={true}>
                {company.name}
            </Text>
            <div className="edit-icon-wrapper" onClick={handleEdit} role="button" onKeyDown={handleEdit} tabIndex={0}>
                <IconEdit size="xs" />
            </div>
        </>
    );

    return (
        <div className="UsersPage-header">
            <Row>
                <Col>
                    {isEditing ? renderEditName() : renderHeading()}
                </Col>
            </Row>
            <StyledContainer className="UsersPage-SubNav">
                <Row noPadding={true} className="full-width">
                    <Col>
                        <StyledContainer>
                            <ul className="UsersPage-SubNav-list">
                                <li
                                    className={cx('TabMenuItem-links', {
                                        'TabMenuItem-active': activeTab === TabList.users,
                                    })}
                                    onClick={() => loadTab(paths.userManagementUsers)}
                                >
                                    <Text
                                        type="body"
                                        className={cx({ 'Utils-primary': activeTab === TabList.users })}
                                    >
                                        Active Users
                                        {company.userCount > 0 && (
                                            <span className="UsersPage-tab-count">
                                                {company.userCount}
                                            </span>
                                        )}
                                    </Text>
                                </li>
                                <li
                                    className={cx('TabMenuItem-links', {
                                        'TabMenuItem-active': activeTab === TabList.pending,
                                    })}
                                    onClick={() => loadTab(paths.userManagementPending)}
                                >
                                    <Text
                                        type="body"
                                        className={cx({ 'Utils-primary': activeTab === TabList.pending })}
                                    >
                                        Pending Users
                                        {company.pendingUserCount > 0 && (
                                            <span className="UsersPage-tab-count">
                                                {company.pendingUserCount}
                                            </span>
                                        )}
                                    </Text>
                                </li>
                                <li
                                    className={cx('TabMenuItem-links', {
                                        'TabMenuItem-active': activeTab === TabList.activity,
                                    })}
                                    onClick={() => loadTab(paths.userManagementActivity)}
                                >
                                    <Text
                                        type="body"
                                        className={cx({ 'Utils-primary': activeTab === TabList.activity })}
                                    >
                                        Activity History
                                    </Text>
                                </li>
                                <li
                                    className="TabMenuItem-links TabMenuItem-Right"
                                >
                                    <Button
                                        type="primary"
                                        full={true}
                                        onClick={handleAddUser}
                                    >
                                        Add a new user
                                    </Button>
                                </li>
                            </ul>
                        </StyledContainer>
                    </Col>
                </Row>
            </StyledContainer>
        </div>
    );
};

export default connect()(withRouter(UserManagementNav));
